import { render, staticRenderFns } from "./filePreviewform.vue?vue&type=template&id=2baba728&scoped=true&"
import script from "./filePreviewform.vue?vue&type=script&lang=js&"
export * from "./filePreviewform.vue?vue&type=script&lang=js&"
import style0 from "./filePreviewform.vue?vue&type=style&index=0&id=2baba728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baba728",
  null
  
)

export default component.exports